import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { DocumentTypeApi } from '../../services/ApiService';

function DocumentTypeEdit() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    if (id) {
      DocumentTypeApi.getDocumentType(id)
        .then((res) => {
          if (!res.ok) throw new Error("Failed to fetch Document Type");
          return res.json();
        })
        .then((data) => {
          setName(data.name);
          setDescription(data.description || "");
        })
        .catch((err) => console.error(err));
    }
  }, [id]);

  function handleSave(e) {
    e.preventDefault();
    if (!name.trim()) {
      alert("Name is required.");
      return;
    }
    const payload = { name, description };

    if (id) {
      // Update
      DocumentTypeApi.updateDocumentType(id, payload)
        .then((res) => {
          if (!res.ok) throw new Error("Failed to update Document Type");
          navigate("/settings/document-types");
        })
        .catch((err) => console.error(err));
    } else {
      // Create
      DocumentTypeApi.createDocumentType(payload)
        .then((res) => {
          if (!res.ok) throw new Error("Failed to create Document Type");
          navigate("/settings/document-types");
        })
        .catch((err) => console.error(err));
    }
  }

  return (
    <div>
      <h2>{id ? "Edit Document Type" : "Create Document Type"}</h2>
      <form onSubmit={handleSave}>
        <div>
          <label>Name:</label>
          <br />
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>
        <div style={{ marginTop: "1rem" }}>
          <label>Description:</label>
          <br />
          <textarea
            rows="3"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>

        <div style={{ marginTop: "1rem" }}>
          <button type="submit">Save</button>{" "}
          <button
            type="button"
            onClick={() => navigate("/settings/document-types")}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}

export default DocumentTypeEdit;
